export const initialState = {
    collectionsList: [],
    activeCollections:null,
    collectionsRes:null
  };